import { Client } from '@microsoft/microsoft-graph-client';

const getAuthenticatedClient = (accessToken: string) =>
	Client.init({
		authProvider: (callback) => {
			callback(null, accessToken);
		},
	});

export const fetchUserDetails = async (accessToken: string) => {
	const client = getAuthenticatedClient(accessToken);

	return await client.api('/me').get();
};

export const fetchUserProfileImg = async (accessToken: string) => {
	try {
		const client = getAuthenticatedClient(accessToken);
		return await client.api('/me/photo/$value').get();
	} catch (err) {
		return false;
	}
};
